import type { DatasetPlanPositioningEditorWrapperProps } from "./dataset-plan-positioning-editor.type";

import { Empty } from "antd";
import { useTranslation } from "react-i18next";

import { useDatasetPlanPositioningContext } from "../dataset-plan-positioning.context";

import DatasetPlanPositioningEditor from "./dataset-plan-positioning-editor.component";
import { getPlanUrl } from "./dataset-plan-positioning-editor.helper";

const DatasetPlanPositioningEditorWrapper = (
  componentProps: DatasetPlanPositioningEditorWrapperProps
) => {
  const { t } = useTranslation();
  const { template, dataset, asset } = useDatasetPlanPositioningContext();

  if (!template) return null;

  const planUrl = getPlanUrl(dataset, asset);

  if (!planUrl) return <Empty description={t("global:noData")} />;

  return (
    <DatasetPlanPositioningEditor
      {...componentProps}
      template={template}
      planUrl={planUrl}
    />
  );
};

export default DatasetPlanPositioningEditorWrapper;
